/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {BundleTypeBaseContract} from '../../../api/contracts/bundle-type/bundle-type-base.contract';
import {CustomerBaseContract} from '../../../api/contracts/customer/customer-base.contract';
import {BundlingSettingsTabModel} from '../../models/bundling-settings-tabs/bundling-settings-tab.model';

export class BundlingSettingsTabsMapper {

    static fromCustomerBaseContractArrayToBundlingSettingsTabModelArray(customerBase: CustomerBaseContract[]): BundlingSettingsTabModel[] {
        const customerNames: BundlingSettingsTabModel[] = [];
        if (customerBase != null) {
            customerBase.forEach((customer) => {
                customerNames.push({
                    tabCode: customer.code,
                    tabName: customer.shortDescription
                });
            });
        }
        return customerNames;
    }

static fromBundleTypeBaseContractArrayToBundlingSettingsTabModelArray(bundleTypes: BundleTypeBaseContract[]): BundlingSettingsTabModel[] {
        const bundleTypeNames: BundlingSettingsTabModel[] = [];
        if (bundleTypes != null) {
            bundleTypes.forEach((bundleType) => {
                bundleTypeNames.push({
                    tabCode: bundleType.code,
                    tabName: bundleType.name
                });
            });
        }
        return bundleTypeNames;
    }
}
